/* eslint-disable complexity */
import { i18n } from 'next-i18next'
import { BigOrderItem, Order } from '../models'
import { getFormatedPrice } from './currency.helpers'
import { getContributionUnitInUserLanguage } from '../json'


export const getOrderItemUnit = (orderItem: BigOrderItem) => {
  if (orderItem.is_free_donation) return ''
  const unit = getContributionUnitInUserLanguage(
    orderItem.contribution_unit,
    i18n.language,
    orderItem.amount
  )
  return ['compensation', 'carbon_forward'].includes(orderItem.project_kind) ? 'tCO₂'
    : orderItem.project_kind === 'energy'
      ? 'MWh' : orderItem.contribution_unit !== null ? unit
        : orderItem.project_kind === 'biodiversity' ? 'CR' : 'units'
}

export const getOrderItemTotal = (orderItem: BigOrderItem, order: Order, code = 'EUR', isProjectCurrency=false) => {
  if (order.status === 'paid') {
    if (orderItem.customerInvoiceSubtotal) {
      return getFormatedPrice(+orderItem.customerInvoiceSubtotal, code)
    }
    if (
      orderItem.invoiceP2pSubtotalProjectCurrency &&
      orderItem.invoiceP2pVatAmountProjectCurrency &&
      isProjectCurrency
    ) {
      const result = +orderItem.invoiceP2pSubtotalProjectCurrency + +orderItem.invoiceP2pVatAmountProjectCurrency
      return getFormatedPrice(result, code)
    }
    if (
      !orderItem.invoiceFeeBaseAmount ||
      !orderItem.invoiceP2pBaseAmount ||
      !orderItem.invoiceP2pTaxAmount  ||
      !orderItem.invoiceFeeTaxAmount
    ) {
      const result = (+orderItem.amount * +orderItem.order_price) + +orderItem.fee + orderItem.vat
      return getFormatedPrice(result, code)
    }
    const result = +(orderItem.invoiceFeeBaseAmount || 0) + +orderItem.invoiceP2pBaseAmount +
     +orderItem.invoiceP2pTaxAmount + +(orderItem.invoiceFeeTaxAmount || 0)
    return getFormatedPrice(result, code)
  } else {
    const result = (+orderItem.amount * +orderItem.order_price) +
    +orderItem.fee + orderItem.vat
    return getFormatedPrice(result, code)
  }
}

//type OrderType = 'transaction' | 'fee' | 'vat'
type TypeVat = 'p2p' |  'fee' | ''

export const getOrderItemTransactionAmount = (
  order: Order,
  orderItem: BigOrderItem,
  code = 'EUR'
) => {
  if (order.status === 'paid') {
    if (orderItem.invoiceP2pSubtotalProjectCurrency) {
      return getFormatedPrice(+orderItem.invoiceP2pSubtotalProjectCurrency, code)
    }
    return getFormatedPrice(+orderItem.invoiceP2pBaseAmount || +orderItem.breakdownP2pBaseAmount, code)
  } else {
    return getFormatedPrice(+orderItem.amount * +orderItem.order_price, code)
  }
}

export const getOrderItemFeeAmount = (
  order: Order,
  orderItem: BigOrderItem,
  code = 'EUR'
) => {
  if (order.status === 'paid') {
    if (orderItem.customerInvoiceFeeAmount){
      return getFormatedPrice(+orderItem.customerInvoiceFeeAmount, code)
    }
    if (orderItem.invoiceFeeTotalAmountProjectCurrency) {
      return getFormatedPrice(+orderItem.invoiceFeeTotalAmountProjectCurrency, code)
    }
    return getFormatedPrice((+orderItem.invoiceFeeBaseAmount + +orderItem.invoiceFeeTransactionAmount) ||
      (+orderItem.breakdownFeeBaseAmount + +orderItem.invoiceFeeTransactionAmount), code)
  } else {
    return getFormatedPrice(+orderItem.fee, code)
  }
}

export const getOrderItemTransactionFeeAmount = (
  order: Order,
  orderItem: BigOrderItem,
  code = 'EUR'
) => {
  if (order.status === 'paid') {
    return getFormatedPrice(+orderItem.customerInvoiceTransactionFeeAmount, code)
  }
  return getFormatedPrice(+orderItem.fee, code)
}

export const getOrderItemVatAmount = (
  order: Order,
  orderItem: BigOrderItem,
  typeVat: TypeVat,
  code = 'EUR'
) => {
  if (order.status === 'paid') {
    if (typeVat === 'p2p') {
      if (orderItem.invoiceP2pVatAmountProjectCurrency) {
        return getFormatedPrice(+orderItem.invoiceP2pVatAmountProjectCurrency, code)
      }
      return getFormatedPrice(+orderItem.invoiceP2pTaxAmount || +orderItem.breakdownP2pTaxAmount, code)
    } else {
      if (orderItem.invoiceFeeVatAmountProjectCurrency) {
        return getFormatedPrice(+orderItem.invoiceFeeVatAmountProjectCurrency, code)
      }
      return getFormatedPrice(+orderItem.invoiceFeeTaxAmount || +orderItem.breakdownFeeTaxAmount, code)
    }
  } else {
    return getFormatedPrice(+orderItem.vat, code)
  }
}

export const getOrderItemVatAmountForCustomerInvoice = (
  order: Order,
  orderItem: BigOrderItem,
  code = 'EUR'
) => {
  if (order.status === 'paid') {
    if (orderItem.customerInvoiceVatAmount) {
      return getFormatedPrice(+orderItem.customerInvoiceVatAmount, code)
    }
    return getFormatedPrice(+orderItem.breakdownP2pTaxAmount, code)
  } else {
    return getFormatedPrice(+orderItem.vat, code)
  }
}

export const getOrderItemUnitPrice = (orderItem: BigOrderItem, code: string): string => {
  const p2pUnitPrice = +orderItem.invoiceP2pUnitPriceProjectCurrency
  const customerUnitPrice = +orderItem.customerInvoiceUnitPrice
  const defaultPrice = +orderItem.order_price
  const amount = p2pUnitPrice || customerUnitPrice || defaultPrice
  const currency = orderItem.order_currency || code
  return getFormatedPrice(amount, currency)
}

export const getOrderItemProjectUnitPrice = (orderItem: BigOrderItem, code: string): string => {
  const p2pUnitPrice = +orderItem.invoiceP2pUnitPriceProjectCurrency
  const customerUnitPrice = +orderItem.customerInvoiceUnitPrice
  const defaultPrice = +orderItem.order_price
  const amount = p2pUnitPrice || customerUnitPrice || defaultPrice
  const currency = orderItem.project_currency_code || code
  return getFormatedPrice(amount, currency)
}
